import React, { useCallback, useState } from "react";
import EventCard from "./EventCard";
import AccordianOpen from "@/src/assets/AccordianOpen";
import AccordianClose from "@/src/assets/AccordianClose";
import InfoIcon from "@/src/assets/InfoIcon";
import gameAssets from "@themed-assets";
import {
  TOURNEY_INFO_FLIGHTS_TAB,
  TOURNEY_STATUS_CANCELLED,
  TOURNEY_STATUS_COMPLETED,
  TOURNEY_STATUS_LIVE,
  TOURNEY_STATUS_MISSED,
  TOURNEY_STATUS_WON,
} from "@/Poker/data/Constants";
import useGetSingleTourneyDefinitionById from "@/src/hooks/data/useGetSingleTourneyDefinitionById";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import TourneyInfoCard from "./TourneyInfoCard";
import { AnimatePresence, motion } from "framer-motion";

function TourneyDetailsFlights({ selectedTourneyDetails, tourneyNav }) {
  const [activeTab, setActiveTab] = useState("similar"); // similar or satellite
  const [selectedCardIndex, setSelectedCardIndex] = useState("");

  const {
    buyIn,
    tourneyRake,
    registeredPlayerCount,
    maxPlayers,
    displayWinners,
    totalAddOns,
    addOnAmount,
    rebuyFee,
    startingStack,
    playersPerTable,
    prizePool,
    currentLevel,
    nextLevel,
    nextBreak,
    highestStack,
    blindStructure,
    tourneyStartTime,
    tourneyStatus,
    lateRegistrationAllowed,
    maxRebuyCount,
    tourneyRules,
    winnersPayoutWithBonus,
    breakEven,
    dynamicPoolPrize,
    tournamentType,
    lateRegistrationDuration,
    rebuyLevel,
    childTourneys,
    prizePoolTickets,
    lateRegEnded,
    reEntry,
    parentTourney,
    levelDuration,
    totalAddOnCount,
    totalRebuyCount,
    totalReEntryCount,
    isAlreadyRegisteredTourney,
    tourneyId,
    prizePoolType,
    payoutType,
    hideRegistrationCTAButtons,
    tourneyIdentifier,
    activePlayerForTourney,
    breakInProgress,
    breakEndTime,
    averageChips,
    lateRegEndTime,
    depositTourneyFlag,
    allowedFreeRegistrations,
    allowedTicketRegistrations,
    isFlightTourney,
    isFlightParentTourney,
    similarFlights,
    parentTourneyName,
    qualifiedPlayers,
  } = selectedTourneyDetails;

  const masterTourneysData = useSelector(
    (state) => state.lobby.masterTourneysData
  );
  const handleTourneyClick = (tourneyId) => {
    tourneyNav.navigateToTourneyDetails(tourneyId);
  };
  const RenderChildFlightTourneyDetails = ({ tourneyId, index }) => {
    const tourneyDetails = useGetSingleTourneyDefinitionById(tourneyId);
    if (!tourneyDetails) {
      return null;
    }
    const { tourneyName, buyIn, tourneyRake, tourneyStatus, tourneyStartTime } =
      tourneyDetails;

    console.log("RenderChildFlightTourneyDetails: ", tourneyDetails);
    return (
      <div className="bg-foreground mb-2 rounded overflow-hidden">
        <div
          className="px-3 pt-3 "
          onClick={() => {
            console.log("clicked accordian", tourneyDetails.tourneyStatus);
            if (tourneyDetails.tourneyStatus !== "CANCELLED") {
              setSelectedCardIndex(
                selectedCardIndex == tourneyId ? null : tourneyId
              );
            }
          }}
        >
          <div
            className={`flex items-center justify-between ${
              tourneyId == selectedCardIndex ? "border-b border-light/40" : ""
            } pb-3`}
          >
            <div
              onClick={() => handleTourneyClick(tourneyId)}
              className={`w-3/9 text-xs ${
                tourneyStatus == "CANCELLED" ||
                tourneyStatus == "COMPLETED" ||
                tourneyStatus == "Missed"
                  ? "text-fade"
                  : "text-secondary"
              }`}
            >
              {tourneyName?.length > 15
                ? tourneyName.slice(0, 12) + "..."
                : tourneyName}
            </div>
            <div
              className={`w-3/9 text-xs ${
                tourneyStatus == "CANCELLED" ||
                tourneyStatus == "COMPLETED" ||
                tourneyStatus == "Missed"
                  ? "text-fade"
                  : "text-secondary"
              }`}
            >{`₹${buyIn + tourneyRake}`}</div>
            {tourneyDetails.tourneyIdentifier === "completedTourneys" ? (
              <div className="w-3/9  flex items-center justify-between">
                <div className="flex items-center">
                  {tourneyStatus == "LIVE" && (
                    <div className="w-1 h-1 rounded-full bg-success mr-1" />
                  )}
                  <div className="text-xs text-fade">
                    {tourneyStatus == "LIVE"
                      ? "Running"
                      : tourneyStatus == "CANCELLED"
                      ? "Cancelled"
                      : tourneyStatus == "COMPLETED" ||
                        tourneyStatus == "Missed"
                      ? "Finished"
                      : format(
                          new Date(tourneyStartTime * 1000),
                          "dd MMM, hh:mm a"
                        )}
                  </div>
                </div>
                {tourneyStatus !== "CANCELLED" && (
                  <div
                    className={`bg-tab-bg rounded-full w-4 h-4 flex items-center justify-center`}
                  >
                    {selectedCardIndex == tourneyId ? (
                      <AccordianOpen />
                    ) : (
                      <AccordianClose />
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="w-3/9  flex items-center justify-between">
                <div className="flex items-center">
                  {tourneyStatus == "LIVE" && (
                    <div className="w-1 h-1 rounded-full bg-success mr-1" />
                  )}
                  <div className="text-xs text-primary">
                    {tourneyStatus == "LIVE"
                      ? "Running"
                      : tourneyStatus == "CANCELLED"
                      ? "Cancelled"
                      : tourneyStatus == "COMPLETED" ||
                        tourneyStatus == "Missed"
                      ? "Finished"
                      : format(
                          new Date(tourneyStartTime * 1000),
                          "dd MMM, hh:mm a"
                        )}
                  </div>
                </div>
                <div
                  className={`bg-tab-bg rounded-full w-4 h-4 flex items-center justify-center`}
                >
                  {selectedCardIndex == tourneyId ? (
                    <AccordianOpen />
                  ) : (
                    <AccordianClose />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <AnimatePresence>
          {tourneyId == selectedCardIndex && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <TourneyInfoCard
                tourneyDetails={tourneyDetails}
                activeTab={activeTab}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };

  const getTourneyDefinitionByTourneyId = (tourneyId) => {
    console.log(tourneyId, "tourneyIdtourneyId");
    const tourney = masterTourneysData.get(tourneyId);
    return tourney ? tourney : false;
  };

  const getSortedList = (tourneyList, asc) => {
    return tourneyList.sort((a, b) => {
      const aStartTime = a.tourneyStartTime || 0;
      const bStartTime = b.tourneyStartTime || 0;
      if (asc) {
        return aStartTime - bStartTime;
      } else {
        return bStartTime - aStartTime;
      }
    });
  };

  const renderFlightTourneysDetails = useCallback(() => {
    const tourneyIdsList =
      activeTab === "similar" ? similarFlights : childTourneys;
    const tourneyDefinitions = tourneyIdsList.map((tourneyDetails) =>
      getTourneyDefinitionByTourneyId(tourneyDetails)
    );

    console.log(
      "tourneyList: ",
      tourneyIdsList,
      "tourneyDefinitions",
      tourneyDefinitions
    );

    if (tourneyDefinitions.length === 0) {
      return activeTab !== "similar" ? (
        <div className="flex flex-col items-center justify-center h-64 w-full">
          <img width={50} height={50} src={gameAssets.EmptyFolder} />
          <div className="text-sm text-primary">
            All Satellites for this tournament have successfully concluded
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-64 w-full">
          <img width={50} height={50} src={gameAssets.EmptyFolder} />
          <div className="text-sm text-primary mt-4 text-center">
            No Similar flights available
          </div>
        </div>
      );
    }

    const runningTourneys = [];
    const completedTourneys = [];
    const yetToStartTourneysList = [];
    const cancelledTourneys = [];

    tourneyDefinitions.forEach((tourneyDetails) => {
      if (tourneyDetails) {
        switch (tourneyDetails?.tourneyStatus) {
          case TOURNEY_STATUS_COMPLETED:
          case TOURNEY_STATUS_WON:
          case TOURNEY_STATUS_MISSED:
            completedTourneys.push(tourneyDetails);
            break;
          case TOURNEY_STATUS_CANCELLED:
            cancelledTourneys.push(tourneyDetails);
            break;
          case TOURNEY_STATUS_LIVE:
            runningTourneys.push(tourneyDetails);
            break;
          default:
            yetToStartTourneysList.push(tourneyDetails);
        }
      }
    });

    return (
      <>
        <div className={`rounded-200 bg-foreground/55 mt-5 p-3`}>
          <div className="flex items-center justify-between p-2 ">
            <div className="w-3/9 text-xs text-secondary">NAME</div>
            <div className="w-3/9 text-xs text-secondary">BUYIN</div>
            <div className="w-3/9 text-xs text-secondary">START TIME</div>
          </div>
          {runningTourneys.length > 0 && (
            <div>
              <div className="flex items-center px-1 pb-2">
                <div className="w-2 h-2 rounded-full bg-success mr-1" />
                <div className="text-xs font-medium text-secondary">Live</div>
              </div>
              {getSortedList(runningTourneys, true).map((tourney, index) => (
                <RenderChildFlightTourneyDetails
                  key={tourney.tourneyId}
                  tourneyId={tourney.tourneyId}
                  index={index}
                />
              ))}
            </div>
          )}
          {yetToStartTourneysList.length > 0 && (
            <div>
              <div className="flex items-center px-1 pb-2">
                <div className="w-2 h-2 rounded-full bg-success mr-1" />
                <div className="text-xs font-medium text-secondary">
                  Yet to start
                </div>
              </div>
              {getSortedList(yetToStartTourneysList, true).map(
                (tourney, index) => (
                  <RenderChildFlightTourneyDetails
                    tourneyId={tourney.tourneyId}
                    index={index}
                  />
                )
              )}
            </div>
          )}
          {completedTourneys.length > 0 && (
            <div>
              <div className="flex items-center px-1 pb-2">
                <div className="w-2 h-2 rounded-full bg-alt mr-1" />
                <div className="text-xs font-medium text-secondary">
                  Completed
                </div>
              </div>
              {getSortedList(completedTourneys, false).map((tourney, index) => (
                <RenderChildFlightTourneyDetails
                  tourneyId={tourney.tourneyId}
                  index={index}
                />
              ))}
            </div>
          )}
          {cancelledTourneys.length > 0 && (
            <div>
              <div className="flex items-center px-1 pb-2">
                <div className="w-2 h-2 rounded-full bg-focus mr-1" />
                <div className="text-xs font-medium text-secondary">
                  Cancelled
                </div>
              </div>
              {getSortedList(cancelledTourneys, false).map((tourney, index) => (
                <RenderChildFlightTourneyDetails
                  tourneyId={tourney.tourneyId}
                  index={index}
                />
              ))}
            </div>
          )}
        </div>
      </>
    );
  }, [activeTab, childTourneys, similarFlights, selectedCardIndex]);

  return (
    <div>
      <EventCard
        isFlightParentTourney={isFlightParentTourney}
        parentTourneyName={parentTourneyName}
        parentTourney={parentTourney}
      />
      {childTourneys.length > 0 && (
        <div className="mt-5 flex items-center">
          <div
            className={`rounded-300  border  text-xs font-medium px-3 py-2 mr-2
        ${
          activeTab == "similar"
            ? "bg-header-accent text-primary shadow-[2px_2px_15px] shadow-header-accent border border-cta"
            : "bg-transparent border-secondary text-primary"
        }
        `}
            onClick={() => {
              setActiveTab("similar");
            }}
          >
            Similar Flights
          </div>
          <div
            className={`rounded-300  border  text-xs font-medium  px-3 py-2 mr-2
        ${
          activeTab == "satellite"
            ? "bg-header-accent text-primary shadow-[2px_2px_15px] shadow-header-accent border border-cta"
            : "bg-transparent border-secondary text-primary"
        }
        `}
            onClick={() => {
              setActiveTab("satellite");
            }}
          >
            Satellites for this event
          </div>
        </div>
      )}
      {renderFlightTourneysDetails()}
    </div>
  );
}

export default TourneyDetailsFlights;
